function setVH() {
  window.document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`
  );
}

global.addEventListener('resize', setVH);

setVH();
